var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0C14.1046 0 15 0.89543 15 2V3H16.5194C17.1269 3 17.7016 3.27618 18.0811 3.75061L19.5617 5.6014C19.8454 5.956 20 6.3966 20 6.8508V11C20 12.1046 19.1046 13 18 13C18 14.6569 16.6569 16 15 16C13.3431 16 12 14.6569 12 13H8C8 14.6569 6.65685 16 5 16C3.34315 16 2 14.6569 2 13C0.89543 13 0 12.1046 0 11V2C0 0.89543 0.89543 0 2 0H13ZM5 12C4.44772 12 4 12.4477 4 13C4 13.5523 4.44772 14 5 14C5.55228 14 6 13.5523 6 13C6 12.4477 5.55228 12 5 12ZM15 12C14.4477 12 14 12.4477 14 13C14 13.5523 14.4477 14 15 14C15.5523 14 16 13.5523 16 13C16 12.4477 15.5523 12 15 12ZM13 2H2V11H2.76389C3.31321 10.3863 4.1115 10 5 10C5.82015 10 6.56344 10.3292 7.105 10.8625L7.23611 11H12.7639L12.8787 10.8787L13 10.7639V2ZM16.5194 5H15V10C15.8202 10 16.5634 10.3292 17.105 10.8625L17.2361 11H18V6.8508L16.5194 5Z",
    fill: "#0D283E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.00778f4914d5525256d2bfe173c69c8f.svg";
export { ForwardRef as ReactComponent };